<div class="autoCell-job-container">
    <form class="form-container job-selection-dialog-content" [formGroup]="autoCellDetectForm">
        <cds-form-group>
            <div class="experiment-name-input">
                <cds-input controlWidth="shrink">
                    <label>Name</label>
                    <input type="text" [formControlName]="NEW_EXPERIMENT_NAME_KEY" />
                </cds-input>
            </div>
            <div class="intensity-map-input">
                <cds-select class="intensity-map-dropdown" controlWidth="shrink">
                    <label>Intensity Maps</label>
                    <select [formControlName]="SELECTED_INTENSITY_MAP_KEY">
                        <option *ngFor="let segobjectmap of segObjectPropertyMaps$ | async">
                            {{ segobjectmap.name }}
                        </option>
                    </select>
                </cds-select>
            </div>
            <div class="checkbox-group">
                <label>Input feature</label>
                <div>
                    <cds-checkbox>
                        <label>Marker</label>
                        <input
                            type="checkbox"
                            [formControlName]="LAYER_TYPE_MARKERS_KEY"
                            (change)="onMarkerCheckboxChange($event)"
                        />
                    </cds-checkbox>
                    <div
                        class="marker-options"
                        *ngIf="autoCellDetectForm.get(LAYER_TYPE_MARKERS_KEY)?.value"
                    >
                        <ng-container *ngFor="let marker of sourceLayers$ | async">
                            <cds-checkbox>
                                <label>{{ marker.name }}</label>
                                <input
                                    type="checkbox"
                                    [checked]="
                                        autoCellDetectForm.get(LAYER_TYPE_MARKERS_KEY)?.value
                                    "
                                    [disabled]="
                                        !autoCellDetectForm.get(LAYER_TYPE_MARKERS_KEY)?.value
                                    "
                                    (change)="selectMarkers(marker.name!)"
                                />
                            </cds-checkbox>
                        </ng-container>
                    </div>
                    <cds-checkbox>
                        <label>Transcripts</label>
                        <input type="checkbox" [formControlName]="LAYER_TYPE_TRANSCRIPTS_KEY" />
                    </cds-checkbox>
                    <cds-checkbox>
                        <label>Morphometrics</label>
                        <input type="checkbox" [formControlName]="LAYER_TYPE_MORPHOMETRICS_KEY" />
                    </cds-checkbox>
                </div>
            </div>
        </cds-form-group>
        <div class="actions submit-button">
            <cds-button size="sm" (click)="startJob()" [disabled]="!enableJobButton">
                Start Job
            </cds-button>
        </div>
    </form>
</div>
